// config.js
const config = {
    apiPath: window.location.origin,
    // apiPath: "http://127.0.0.1:8000",
    // apiPath: "https://www.epicip.com",
    // apiPath: "https://demo.epicip.com",
};

export default config;